import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

/**
 * @email WY <yang.wang06@hand-china.com>
 * @creationDate 2019/12/25
 * @copyright HAND ® 2019
 */
import request from "../../utils/request";
import { getEnvConfig } from "../../utils/iocUtils";
import { getResponse } from "../../utils/utils";
var _getEnvConfig = getEnvConfig(),
  HZERO_PLATFORM = _getEnvConfig.HZERO_PLATFORM;
/**
 * 获取加密公钥
 */

export function getPublicKey() {
  return _getPublicKey.apply(this, arguments);
}
function _getPublicKey() {
  _getPublicKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            res = request("".concat(HZERO_PLATFORM, "/v1/tool/pass/public-key"), {
              method: 'GET'
            }); // FIXME: @WJC utils need fix
            // @ts-ignore

            return _context.abrupt("return", getResponse(res));
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getPublicKey.apply(this, arguments);
}